module.exports = __webpack_public_path__ + "img/rotate90degree_w.9f9e3f27.svg";